"use client";

import { ErrorContent } from "modules/common/components/ErrorContent";
import { getUserFriendlyMessage } from "utils/error-sanitizer";

type ErrorProps = {
  error: Error & { digest?: string };
  reset: () => void;
};

export default function ErrorComponent({ error }: ErrorProps) {
  return (
    <ErrorContent
      message={getUserFriendlyMessage(error)}
      primaryLink={{ label: "Return to Homepage", href: "/" }}
    />
  );
}
